import { connectFela } from 'modules/reports/dependencies';
import SelectPresetInput from './SelectPresetInput';
import * as styles from './SelectPresetInput.styles';

export default connectFela(styles)(SelectPresetInput);
